export default "__VITE_ASSET__YVIj6e74__"